export const COLOR_DEFAULT_CLEAR_BG = 0x705067;

// 2 colors only
export const DEFAULT_BG_GRADIENT = {
    colors: [0x65586c, 0x546a6c]
};

const NEW_RENAISSANCE_BG_GRADIENT = {
    colors: [0xfecbbe, 0xfef6f3]
};

const PERSON_THEME_BG_GRADIENT = {
    colors: [0x7a6161, 0x4b3a3a]
};

const SCREEN_LIFE_THEME_BG_GRADIENT = {
    colors: [0x7a5d50, 0xf3efdd]
};

const TYPOGRAPHY_THEME_BG_GRADIENT = {
    colors: [0x403838, 0x796a6f, 0x705067],
    ratios: [0, 0.47, 1]
};

const CRAFT_THEME_BG_GRADIENT = {
    colors: [0xa296c0, 0xf1ddff]
};

export const COLOR_SCHEMES = {
    default: {
        bg: DEFAULT_BG_GRADIENT,
        fog: 0x65586c,
        previewGradientMap: {
            color0: 0x735d46,
            color1: 0xeae5d2
        }
    },
    'new-renaissance': {
        bg: NEW_RENAISSANCE_BG_GRADIENT,
        fog: 0xfecbbe,
        previewGradientMap: {
            color0: 0xbd6e8d,
            color1: 0xfdf0d3
        }
    },
    'user-generated': {
        bg: PERSON_THEME_BG_GRADIENT,
        fog: 0x7a6161,
        previewGradientMap: {
            color0: 0x493341,
            color1: 0xfff2e9
        }
    },
    'screen-life': {
        bg: SCREEN_LIFE_THEME_BG_GRADIENT,
        fog: 0xa28f7e,
        previewGradientMap: {
            color0: 0x905664,
            color1: 0xeae5d2
        }
    },
    'dynamic-typography': {
        bg: TYPOGRAPHY_THEME_BG_GRADIENT,
        fog: 0x796a6f,
        previewGradientMap: {
            color0: 0x4b3a3a,
            color1: 0x7a6161
        }
    },
    craft: {
        bg: CRAFT_THEME_BG_GRADIENT,
        fog: 0xa296c0,
        previewGradientMap: {
            color0: 0x45857a,
            color1: 0xeee3ff
        }
    }
};

export const COLOR_THEMES = {
    light: {
        text: 0x2b2b2b
    },
    dark: {
        text: 0xfff4e1
    }
};
